import { differenceInHours } from 'date-fns'
const Cancellation_LIMIT_HOURS = 4
const Cancellation_WARNING_LIMIT_HOURS = 24

export const getDiffInHours = (appointmentDate: Date) => {
  const diffInHours = differenceInHours(appointmentDate, new Date())

  return diffInHours
}

export const isTooLateToCancel = (timeDiffInHours: number) => timeDiffInHours < Cancellation_LIMIT_HOURS
export const cancellationPossibleWithWarning = (timeDiffInHours: number) =>
  timeDiffInHours < Cancellation_WARNING_LIMIT_HOURS && timeDiffInHours >= Cancellation_LIMIT_HOURS
